import { render, staticRenderFns } from "./recoverpasswordprofile.vue?vue&type=template&id=0b37e4ee&scoped=true&"
import script from "./recoverpasswordprofile.vue?vue&type=script&lang=js&"
export * from "./recoverpasswordprofile.vue?vue&type=script&lang=js&"
import style0 from "./recoverpasswordprofile.vue?vue&type=style&index=0&id=0b37e4ee&scoped=true&lang=css&"
import style1 from "./recoverpasswordprofile.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b37e4ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VContainer,VForm,VRow,VTextField})
